import { i18n } from '../translate/i18n';

const getReason = (equipment) => {
    const reason = equipment.reason;

    let text = '';
    if (reason.inDelay > 0) text += `${reason.inDelay} ${reason.inDelay === 1 ? i18n.t('reasonNames.inDelay') : i18n.t('reasonNames.inDelayMany')}. `;
    if (reason.notDone > 0) text += `${reason.notDone} ${reason.notDone === 1 ? i18n.t('reasonNames.notDone') : i18n.t('reasonNames.notDoneMany')}. `;
    if (reason.hasActionsOpenedOrOverdue > 0) text += `${reason.hasActionsOpenedOrOverdue} ${reason.hasActionsOpenedOrOverdue === 1 ? i18n.t('reasonNames.hasActionsOpenedOrOverdue') : i18n.t('reasonNames.hasActionsOpenedOrOverdueMany')}. `;
    if (reason.hasNoServices) text += i18n.t('reasonNames.hasNoServices') + '. '
    text = text.trim();

    return text;
};

export default getReason;
